// src/components/effects/ConfettiLayer.jsx
import React from "react";

export const ConfettiLayer = ({
  pieces = 160,
  continuous = false,
  zIndex = 40,
}) => {
  const items = Array.from({ length: pieces }).map((_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 1.5,
    duration: 3 + Math.random() * 2.5,
    size: 6 + Math.floor(Math.random() * 6),
    rotate: Math.random() * 360,
    bg: ["#ff4757", "#ffa502", "#2ed573", "#1e90ff", "#a29bfe"][i % 5],
  }));

  return (
    <div
      className="pointer-events-none fixed inset-0 overflow-hidden"
      style={{ zIndex }}
    >
      <style>{`
        @keyframes fallSpin {
          0%   { transform: translateY(-10vh) rotate(0deg);   opacity: .85; }
          100% { transform: translateY(110vh) rotate(720deg); opacity: .0;  }
        }
      `}</style>

      {items.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            top: "-10vh",
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.6,
            background: p.bg,
            transform: `rotate(${p.rotate}deg)`,
            // 👇 si continuous=true: animación infinita; si no, solo una caída
            animation: `fallSpin ${p.duration}s linear ${p.delay}s ${
              continuous ? "infinite" : "forwards"
            }`,
            borderRadius: 2,
            boxShadow: "0 0 6px rgba(0,0,0,.25)",
          }}
        />
      ))}
    </div>
  );
};
